module.exports = __webpack_public_path__ + "img/pleasewait.397d35ac.png";